export default "__VITE_ASSET__c368cdd5__$_?nuxt_component=async&nuxt_component_name=SvgoFivefest__"